import { render, staticRenderFns } from "./HorizontalNavMenuItem.vue?vue&type=template&id=4ed5794c"
import script from "./HorizontalNavMenuItem.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenuItem.vue?vue&type=script&lang=js"
import style0 from "./HorizontalNavMenuItem.vue?vue&type=style&index=0&id=4ed5794c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ed5794c')) {
      api.createRecord('4ed5794c', component.options)
    } else {
      api.reload('4ed5794c', component.options)
    }
    module.hot.accept("./HorizontalNavMenuItem.vue?vue&type=template&id=4ed5794c", function () {
      api.rerender('4ed5794c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/horizontal-nav-menu/HorizontalNavMenuItem.vue"
export default component.exports